export const googleDriveFoldersUrl = "https://drive.google.com/drive/folders";
export function getGoogleDriveLink(folderId: string = "") {
  return `${googleDriveFoldersUrl}/${folderId}`;
}
